import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TableRowComponent } from './table-row.component';

@Component({
  selector: 'mtg-table-header-row',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderRowComponent extends TableRowComponent {
  @HostBinding('class.header')
  headerClass = true;
}
